import React from "react";
import Article from "../../article/article.component";
import styles from './articlesPage.component.less'
function ArticlesPage(props)
{
    let articlesDom = props.data.map(line=>{
        return line.isHidden ? <></> : <Article key={line.id} value = {line}/>;
    });
    return (
        <div className={styles.articles}>
            {articlesDom}
        </div>
    );
}

export default ArticlesPage;